import { render, staticRenderFns } from "./formForgot.vue?vue&type=template&id=0a01e90f&scoped=true"
import script from "./formForgot.vue?vue&type=script&lang=js"
export * from "./formForgot.vue?vue&type=script&lang=js"
import style0 from "./formForgot.vue?vue&type=style&index=0&id=0a01e90f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a01e90f",
  null
  
)

export default component.exports